import React, { useEffect } from 'react';
import { useJessibuca } from '../../hooks/useJessibuca';

export const VTVideoContainer = ({ url, elementId, isEnded, onRefresh }) => {
  const isJessibucaLoaded = useJessibuca();

  useEffect(() => {
    if (!url || isEnded || !elementId) return;

    let jessibucaPlayer = null;

    try {
      if (url.includes('mp4')) {
        const videoElement = document.getElementById(elementId);
        if (!videoElement) return;

        videoElement.src = url;
        videoElement.loop = true;
        videoElement.load();
        videoElement.play().catch(() => {});

        return () => {
          videoElement.pause();
          videoElement.removeAttribute('src');
          videoElement.load();
        };
      } else if (isJessibucaLoaded && window.Jessibuca) {
        const container = document.getElementById(elementId);
        if (!container) return;

        container.innerHTML = ''; // clear any previous player elements

        jessibucaPlayer = new window.Jessibuca({
          container: container,
          decoder: '/jessibuca/decoder.js',
          isFlv: true,
          videoBuffer: 1,
          isResize: true,
          loadingText: 'Loading...',
          supportDblclickFullscreen: false,
          showBandwidth: true,
          operateBtns: {
            fullscreen: true,
            play: false,
            pause: false,
            screenshot: false,
            audio: true,
          },
          progressBar: false,
        });

        const wsUrl = url.replace('https', 'wss');
        jessibucaPlayer.play(wsUrl);

        return () => {
          if (jessibucaPlayer) {
            try {
              jessibucaPlayer.pause();
              jessibucaPlayer.destroy();
            } catch (e) {
              console.error('Error destroying Jessibuca player:', e);
            }
            jessibucaPlayer = null;
          }
        };
      }
    } catch (err) {
      console.error('Jessibuca setup error:', err);
    }
  }, [url, elementId, isEnded, isJessibucaLoaded]);

  if (url.includes('mp4')) {
    return (
      <video
        id={elementId}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
        autoPlay
        playsInline
        muted
      />
    );
  }

  return (
    <div
      id={elementId}
      style={{
        width: '100%',
        height: '100%',
        background: '#000',
        position: 'relative',
      }}
    />
  );
};

export default VTVideoContainer;
